import axios from 'axios';

const CMS_API_BASE_ACCOUNTS = 'https://cms.anatole-school.com/accounts';

export const sendInquiry = async (data) => {
    // 필수 필드 체크: name, contact, message
    const { name, contact, message } = data;
    if (!name) {
        throw new Error("이름(name)을 입력해 주세요.");
    }

    if (!contact) {
        throw new Error("연락처(contact)을 입력해 주세요.");
    }
    if (!message) {
        throw new Error("문의 내용(message)을 입력해 주세요.");
    }

    // CMS가 JSON으로 응답한다. 쿠키를 보내지 않는다(withCredentials 미사용):
    // 로그인 없이 접수하는 공개 엔드포인트이고, CORS 설정도 그에 맞춰져 있다.
    try {
        const response = await axios.post(
            `${CMS_API_BASE_ACCOUNTS}/inquiry/`,
            { name, contact, message },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error("문의 전송 중 오류 발생:", error);
        // CMS가 사유를 내려주면 그대로 보여준다.
        const serverMessage = error?.response?.data?.message;
        throw new Error(serverMessage || '문의 전송에 실패했습니다. 잠시 후 다시 시도해 주세요.');
    }
};
// ---------------------------------------------------------------------------
// 캠퍼스소식 — CMS(Django)의 공개 API. 로그인 없이 읽기만 한다.
// 쿠키를 보내지 않는다(withCredentials 미사용): 공개 데이터이고, CORS 설정도 그에 맞춰져 있다.
// ---------------------------------------------------------------------------
const CMS_API_BASE = 'https://cms.anatole-school.com/api';

export const fetchCampusNewsList = async (limit = 20) => {
    try {
        const response = await axios.get(`${CMS_API_BASE}/campus-news/`, {
            params: { limit },
            headers: { 'Content-Type': 'application/json' },
        });
        return response.data?.news ?? [];
    } catch (error) {
        console.error('캠퍼스소식 목록을 가져오는 중 오류 발생:', error);
        throw error;
    }
};

export const fetchCampusNewsDetail = async (id) => {
    try {
        const response = await axios.get(`${CMS_API_BASE}/campus-news/${id}/`, {
            headers: { 'Content-Type': 'application/json' },
        });
        return response.data;
    } catch (error) {
        console.error('캠퍼스소식을 가져오는 중 오류 발생:', error);
        throw error;
    }
};
